export default {
  install(Vue) {
    // 創建一個全局可訪問的數據存儲
    Vue.prototype.$receiveGPS = Vue.observable({
      latitude: null,
      longitude: null,
      isStart: false,
    })

    // 定義接收裝置資料的全局函數
    window.receiveGPS = function (data) {
      console.log('Received from Native Device:', data)

      try {
        const parsedData = JSON.parse(data)

        // 儲存原始資料
        Vue.prototype.$receiveGPS.rawData = parsedData

        // 解析出經緯度並更新數據
        if (parsedData.latitude !== undefined && parsedData.longitude !== undefined) {
          Vue.prototype.$receiveGPS.latitude = parsedData.latitude
          Vue.prototype.$receiveGPS.longitude = parsedData.longitude

          // 第一次初始化
          if (!Vue.prototype.$receiveGPS.isStart) {
            Vue.prototype.$receiveGPS.isStart = true
          }
        }
      } catch (error) {
        console.error('Error parsing device data:', error)
      }
    }
  },
}
